import { CustomerGroupDto } from '../dtos';

export class CustomerGroupBuilder {
  private customerGroup: CustomerGroupDto;

  constructor() {
    this.customerGroup = new CustomerGroupDto();
  }

  public setId(id: number): CustomerGroupBuilder {
    this.customerGroup.id = id;
    return this;
  }

  public setName(name: string): CustomerGroupBuilder {
    this.customerGroup.name = name;
    return this;
  }

  public setTakeaway(takeaway: boolean): CustomerGroupBuilder {
    this.customerGroup.takeaway = takeaway;
    return this;
  }

  public setPriceLevel(priceLevel: number): CustomerGroupBuilder {
    this.customerGroup.priceLevel = priceLevel;
    return this;
  }
  public setTaxRateShift(taxRateShift: number): CustomerGroupBuilder {
    this.customerGroup.taxRateShift = taxRateShift;
    return this;
  }
  public setPromotions(promotions: number[]): CustomerGroupBuilder {
    this.customerGroup.promotions = promotions;
    return this;
  }
  public setPayments(payments: number[]): CustomerGroupBuilder {
    this.customerGroup.payments = payments;
    return this;
  }

  public build(): CustomerGroupDto {
    return this.customerGroup;
  }
}
